// extracted by mini-css-extract-plugin
export default {"fs":"_2f7d00012f b5eabffa69"};